export default "__VITE_ASSET__f9fb4f59__"